export default "__VITE_ASSET__CFDHzeCo__"